import { camelCase, each, map, range, some } from 'lodash';
import { format } from 'utils';

const displayAttrs = [
  'weight',
  'level',
  'inclineNumber',
  'speed',
  'distance',
  'alternate',
  'eachSide',
];

function buildSteps(items) {
  const steps = [];

  each(items, item => {
    if (item.items) {
      steps.push.apply(steps, buildSteps(item.items));
    } else {
      steps.push(item);
    }
  });

  return steps;
}

function duplicateReps(items, repsCount = 0) {
  const newItems = [];
  const length = items.length;

  each(items, (item, i) => {
    item = { ...item };

    each(range(0, repsCount), j => {
      newItems[i + j * length] = {
        ...item,
        duplicate: j > 0,
        roundNumber: j + 1,
        roundCount: repsCount,
      };
    });

    if (item.items) {
      item.items = duplicateReps(item.items, item.repsCount);
    }

    newItems[i] = item;
  });

  return newItems;
}

function duplicateSets(items) {
  const newItems = [];

  if (items) {
    for (var index = items.length - 1; index >= 0; index--) {
      const item = { ...items[index] };

      if (item.items) {
        item.items = duplicateSets(item.items);
      }

      each(range(0, item.setsCount), i => {
        if (i > 0) {
          const dup = { ...item, setNumber: i + 1 };
          newItems.splice(index + i, 0, dup);
        } else {
          item.setNumber = 1;
          newItems[index] = item;
        }
      });

      newItems[index] = item;
    }
  }

  return newItems;
}

function setStepDisplayAttrs(step) {
  if (!step) {
    return;
  }

  step = { ...step };

  // Normalise attributes
  step.speed = step.speedKms || step.speedMetric;
  step.distance = step.distanceKms || step.distanceMetric;

  // // Weight conversion
  // var weight_captions = [];
  // if (step.weight_base) {
  //   weight_captions.push($filter('convertWeight')(step.weight_base, step.weight_unit, gender));
  // }
  // if (step.weight_range) {
  //   weight_captions.push($filter('convertWeight')(step.weight_base + step.weight_range, step.weight_unit, gender));
  // }
  // if (weight_captions.length > 0) {
  //   step.weight = [weight_captions.join('-'), step.weight_unit].join(' ');
  // }

  const attrs = [];
  const timeAttr = step.repsCount && step.repsCount > 0 ? 'reps' : 'time';

  for (var i in displayAttrs) {
    const attr = displayAttrs[i];
    const val = step[attr];

    let length;

    if (val && parseInt(val) !== 0) {
      length = attrs.unshift(attr);
    }

    if (length === 2) {
      break;
    }
  }

  attrs.unshift(timeAttr);
  step.displayAttributes = attrs;

  return step;
}

function setStepFirstInGroup(step, prevStep) {
  step = { ...step };

  if (!prevStep || prevStep.group.name !== step.group.name) {
    step.firstInGroup = true;
  }

  return step;
}

function setTimeFormats(obj) {
  // TODO: API is returning different responses, check to see if we can get them
  // all the same.
  if (obj.hoursMinutesSeconds && typeof obj.totalTime === 'number') {
    const [hours, minutes, seconds] = obj.hoursMinutesSeconds;
    obj.totalTime = { hours, minutes, seconds };
  }

  obj.totalTimeSet = some(obj.totalTime, time => time > 0);

  if (obj.totalTimeSet) {
    obj.totalTimeDigital = format(obj.totalTime, 'digital');
    obj.totalTimeMinutes = format(obj.totalTime, 'minutes');
    obj.totalTimeVerbose = format(obj.totalTime, 'verbose');
  }
}

function setNoteForItem(item) {
  const parts = [];

  if (item.eachSide) {
    parts.push('Each Side');
  }

  if (item.alternate) {
    parts.push('Alternate L/R');
  }

  if (item.amrap) {
    parts.push('AMRAP');
  }

  item.formattedNote = parts.join(', ');
}

function setMetaForItem(item) {
  if (item.meta) {
    each(item.meta, meta => {
      const key = camelCase(`${meta.name}_${meta.type}`);
      item[key] = meta.display;
    });
  }
}

function decorateWorkoutItems(items) {
  each(items, item => {
    setNoteForItem(item);
    setMetaForItem(item);
    setTimeFormats(item);

    if (item.items) {
      decorateWorkoutItems(item.items);
    }
  });
}

function decorateWorkoutPlayerItems(container, exercises, group, prevRest = 5) {
  each(container.items, item => {
    if (item.items) {
      if (item.name === 'Transition') {
        prevRest = item.totalTimeInSeconds;
      }

      decorateWorkoutPlayerItems(item, exercises, group || item, prevRest);
    } else {
      item.group = group;
      item.parentItem = container;
      item.exercise = exercises[item.exerciseId];

      const nextRest = item.restSeconds;
      item.restSeconds = prevRest;
      prevRest = nextRest;
    }
  });
}

function decorateWorkoutPlayerSteps(steps) {
  let prevStep;

  return map(steps, step => {
    step = setStepDisplayAttrs(step);
    step = setStepFirstInGroup(step, prevStep);

    prevStep = step;

    return step;
  });
}

export const decorateWorkout = workout => {
  if (!workout) {
    return {};
  }

  setTimeFormats(workout);
  decorateWorkoutItems(workout.items);

  return { ...workout };
};

export const decorateWorkoutSteps = (workout, exercises) => {
  if (!workout || !exercises) {
    return [];
  }

  // Decorate the items in the workout
  decorateWorkoutItems(workout.items);
  decorateWorkoutPlayerItems(workout, exercises);

  // Start manipulating the items
  let { items } = workout;
  items = duplicateReps(items);
  items = duplicateSets(items);

  // Flatten the items into steps
  return decorateWorkoutPlayerSteps(buildSteps(items));
};



// WEBPACK FOOTER //
// ./src/decorators/decorateWorkout.js